// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 331) return "static/css/331.759c3d91641ca3811d4e.lib.css";
	if (chunkId === 112) return "static/css/112.90fb0caf979285fbc292.css";
	// return url for filenames based on template
	return undefined;
};